// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../../shared/action-creators/busy-counter';
import {
    readLatestPerUnitMeasurements,
    resetLatestPerUnitMeasurements
} from '../../../../shared/action-creators/latest-per-unit-measurements';
import {
    updateFormValidation,
    updateResponsibleAccount,
    updateUseAmountUnit
} from './claim-details';
import actions from '../../../action-list';
import {canGetProductCustomer} from '../../../../shared/services/privacy';
import {doesAccountHaveMatch} from '../../../shared/services/claim-shared-helper';
import {getDetails} from '../../../../product/shared/repositories';
import {getUnitKey} from '../../../shared/services/get-unit-key';
import {readCustomer} from './get-customer-details';
import {readLaborTypes} from '../../../shared/action-creators/labor-types';

const updateClaimResponsibleAccount = (accountId, productAccountId, dealerCollection, dispatch) => {

    if (!accountId && doesAccountHaveMatch(productAccountId, dealerCollection)) {

        dispatch(updateResponsibleAccount(productAccountId, dealerCollection));
        dispatch(updateFormValidation('responsibleAccount', productAccountId));

    }

    if (accountId) {

        readLaborTypes(accountId)(dispatch);

    }

};

export const readClaimProduct = pin =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        dispatch({
            type: actions.RESET_CLAIM_MAINTENANCE_PLAN_USE_AMOUNT
        });

        try {

            const data = await getDetails(pin);

            const accountId = getState().claims.maintenancePlan.claim.responsibleAccount.account;
            const dealerCollection = getState().user.details.settings.dealer.accounts.allowedAccounts;
            const useAmountUnit = getState().claims.maintenancePlan.claim.useAmount.unit.key;

            dispatch({
                data,
                type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_PRODUCT_DETAILS
            });

            if (canGetProductCustomer(data)) {

                readCustomer(data.customerSummary.id, data.customerPrivate)(dispatch);

            }

            updateClaimResponsibleAccount(accountId, data.dealer.account, dealerCollection, dispatch);

            if (!useAmountUnit) {

                const unitKey = getUnitKey(data);

                dispatch(updateUseAmountUnit(unitKey, data.useAmountAllowedUnits));

            }

            readLatestPerUnitMeasurements(pin)(dispatch);

        } catch (error) {

            dispatch({
                type: actions.RESET_CLAIM_MAINTENANCE_PLAN_PRODUCT_DETAILS
            });

            resetLatestPerUnitMeasurements()(dispatch);

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/action-creators/get-product-details.js